import React, { useState } from "react";
import { X, Settings } from "lucide-react";
import { InputMode, ResponseMode } from "./types";
import { ModeSelector } from "./ModeSelector";

interface SettingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  inputMode: InputMode;
  responseMode: ResponseMode;
  onInputModeChange: (mode: InputMode) => void;
  onResponseModeChange: (mode: ResponseMode) => void;
}

export const SettingsModal: React.FC<SettingsModalProps> = ({
  isOpen,
  onClose,
  inputMode,
  responseMode,
  onInputModeChange,
  onResponseModeChange,
}) => {
  const [selectedInputMode, setSelectedInputMode] = useState(inputMode);
  const [selectedResponseMode, setSelectedResponseMode] =
    useState(responseMode);

  const onSelectedInputMode = (value: InputMode) => {
    setSelectedInputMode(value);
  };

  const onSelectedResponseMode = (value: ResponseMode) => {
    setSelectedResponseMode(value);
  };

  const onDone = () => {
    onInputModeChange(selectedInputMode);
    onResponseModeChange(selectedResponseMode);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="absolute left-0 z-50 flex items-center justify-center overflow-y-auto bottom-10">
      {/* Modal */}
      <div className="relative w-full max-w-md p-6 mx-4 transition-all duration-200 transform bg-white shadow-2xl rounded-xl">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-2">
            <Settings className="w-5 h-5 text-gray-600" />
            <h2 className="text-lg font-semibold text-gray-900">
              FiBi Settings
            </h2>
          </div>
          <button
            onClick={onClose}
            className="p-1 transition-colors duration-200 rounded-lg hover:bg-gray-100"
            aria-label="Close settings"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Mode Selectors */}
        <div className="space-y-6">
          <ModeSelector
            selectedInputMode={selectedInputMode}
            selectedResponseMode={selectedResponseMode}
            onInputModeChange={onSelectedInputMode}
            onResponseModeChange={onSelectedResponseMode}
          />
        </div>

        {/* Footer */}
        <div className="pt-4 mt-6 border-t border-gray-200">
          <button
            onClick={onDone}
            className="w-full px-4 py-2 font-medium text-white transition-colors duration-200 bg-blue-500 rounded-lg hover:bg-blue-600"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};
